import { render, staticRenderFns } from "./CoachManage.vue?vue&type=template&id=51ee1e27"
import script from "./CoachManage.vue?vue&type=script&lang=js"
export * from "./CoachManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports